import '../../styles/templates/template.application.scss'
import Cookies from 'js-cookie'
import {register} from '@shopify/theme-sections'
import $ from 'jquery'
import validate from 'validate.js'
import PhoneUtil from 'google-libphonenumber'
import AffiliateProgram from '../modules/affiliate'
import CheckForUTMvariables from '../modules/utm-fields'
import {v4 as uuidv4} from 'uuid'

import {getApplicationFormSelectors} from '../util/applicationFormSummarySelectors'
import {
    checkIsMobileNumber,
    getRawPhoneNumber,
    initFinanceProductDescriptionText,
    isValidDriversLicence,
    isValidDriversLicenseCardNumber,
    preventEnterKeySubmittingForm,
    setDateOfBirthFieldValues,
    setMiddleNameDropdownEvent,
    setSubmitApplicationFormEvent,
    toggleSearchTypeFields,
    validateMedicare
} from '../modules/financial-application-form-helpers'
import {
    addDealerEventListeners,
    generateMedicareNameOptions,
    resetABNLookupResults,
    resetSelectedBusinessDetails
} from '../components/application-form/helpers'
import {COUNTRY_ISO_CODE} from '../components/application-form/constants'
import {NumberBasedSearch} from '../components/application-form/business-lookup/number-based-search'
import {TextBasedSearch} from '../components/application-form/business-lookup/text-based-search'
import {
    checkAUSite,
    checkCanGoNext,
    checkCASite,
    checkNZSite,
    getStoreCountryCode,
    step4Initial
} from '../modules/sms-validation'
import RenderSummaryPageData from '../modules/financial-application-form-summary'
import GoogleAddressAutocomplete from '../modules/google-address-autocomplete'
import {ApplicationFormInputMasks, businessNumberLookupInputMasks,} from '../modules/input-masks'
import ApplicationPhoneFieldValidation from '../modules/phone-validation'
import {LimelightAccordions} from '../modules/limelight-accordions'

export default register(`template-application`, {
    onLoad() {
        // initialise the dotdev limelight accordions
        LimelightAccordions()

        // Call the UTM Field Function
        CheckForUTMvariables()

        // Call Affiliate function
        AffiliateProgram()

        // Conditionally show the dealer inputs
        addDealerEventListeners()

        const welcome = document.querySelector(`#welcome`)
        const success = document.querySelector(`#success`)
        const next = document.querySelector(`[data-next]`)
        const steps = document.querySelectorAll(`[data-step]`)
        const progress = document.querySelector(`[data-progress]`)
        const stepProgress = document.querySelector(`.steper`)
        const submitApplicationButton = document.querySelector(`[name="appSubmit"]`)
        const start = document.querySelector(`#start`)
        const back = document.querySelector(`[data-back-link]`)
        const form = document.querySelector(`.application-form`)
        const editClick = document.querySelectorAll(`[data-href]`)
        const deleteCookie = document.querySelectorAll(`[data-delete-cookie]`)
        const container = document.querySelector(`.application-form .container`)
        const submissionId = uuidv4()

        // Creating a function to check the phone type
        const phoneUtil = PhoneUtil.PhoneNumberUtil.getInstance()
        const PhoneNumberType = PhoneUtil.PhoneNumberType

        const numberTest = {
            number: {
                format: {
                    pattern: `[a-z0-9]+`,
                    flags: `i`,
                    message: `can only contain a-z and 0-9`,
                },
            },
        }

        /**
         * Application Form Fields Selectors
         * =====================
         */
        const applicationFormSubmitButton = document.getElementById(
            `applicationSubmit`
        )
        const applicationFormElement = document.getElementById(
            `sc-application-form`
        )
        const isAUSite = checkAUSite()
        const isCASite = checkCASite()
        const isNZSite = checkNZSite()
        const LAST_STEP = 4

        const {
            applicationFirstName,
            applicationMiddleName,
            applicationLastName,
            applicationPhone,
            applicationEmail,
            applicationSubmittedBirthday,
            applicationFormattedBirthday,
            applicationAddress,
            applicationAddressCity,
            applicationAddressZip,
            businessToggleCheckbox,
            applicationBusinessAddress,
            applicationBusinessCity,
            applicationBusinessPostcode,
            applicationLegalName,
            applicationPrivateLegalName,
            ABNInput,
            ABNTextSearchInput,
            ABNTextSearchButton,
            ABNResultWrapper,
            hiddenBusinessNumberInputField,
            confirmationBoxBusinessNumberValue,
            confirmationBoxLegalNameValue,
            confirmationBoxIsLegalNameValue
        } = getApplicationFormSelectors()

        // Toggle The Search Type Field
        const searchFields = document.querySelectorAll(`[data-abn-search-fields]`)
        const toggleButtons = document.querySelectorAll(`a[data-toggle-target]`)

        // ABN Result Confirmation Box Container
        const hiddenLegalNameInputField = applicationLegalName
        const hiddenPrivateLegalNameInputField = applicationPrivateLegalName
        const confirmedBusinessDetailsContainer = this.container.querySelector(
            `#confirmed-business-details`
        )
        const ABNTradingName = this.container.querySelector(
            `[data-business-trading-name]`
        )

        // Step 6: Group of Selectors for Business Look up
        const ABNLookupElements = {
            ABNResultWrapper,
            confirmedBusinessDetailsContainer,
            confirmationBoxIsLegalNameValue,
            confirmationBoxLegalNameValue,
            confirmationBoxBusinessNumberValue,
            ABNInput,
            ABNTradingName,
            ABNTextSearchInput,
            hiddenBusinessNumberInputField,
            hiddenLegalNameInputField,
            hiddenPrivateLegalNameInputField,
            next,
        }

        /**
         * Summary / Submit Page Selectors (Final Step)
         */

        if (
            Cookies.get(`_successed_message`) &&
            Cookies.get(`_successed_message`) === 1
        ) {
            success.classList.remove(`hide`)
            welcome.classList.add(`hide`)
        }

        if (deleteCookie && deleteCookie.length > 0) {
            deleteCookie.forEach(element => {
                element.addEventListener(`click`, () => {
                    Cookies.set(`_successed_message`, `0`, {expires: 2})
                })
            })
        }

        if (ABNInput) {
            const ajaxABNLookup = (searchType, elements) => {
                let query
                switch (searchType) {
                    case `numberSearchType`:
                        query = ABNInput.value
                        NumberBasedSearch(query, elements)
                        break
                    case `textSearchType`:
                        query = ABNTextSearchInput.value
                        TextBasedSearch(query, elements, validate)
                        break
                }
            }

            // Bind Events
            ABNInput.addEventListener(
                `input`,
                ajaxABNLookup.bind(null, `numberSearchType`, ABNLookupElements)
            )
            ABNTextSearchButton.addEventListener(
                `click`,
                ajaxABNLookup.bind(null, `textSearchType`, ABNLookupElements)
            )

            // Disable the Enter Key on the ABN Text Search Input from Submitting the Form
            ABNTextSearchInput.addEventListener(`keydown`, e => {
                const key = e.key
                const fallBackKey = e.keyCode || e.which || e.charCode || 0
                if (key && key === `Enter`) {
                    e.preventDefault()
                    e.stopPropagation()
                    TextBasedSearch(ABNTextSearchInput.value, ABNLookupElements, validate)
                    return false
                } else if (fallBackKey && fallBackKey === 13) {
                    e.preventDefault()
                    e.stopPropagation()
                    TextBasedSearch(ABNTextSearchInput.value, ABNLookupElements, validate)
                    return false
                }
            })

            // Bind Click Events to Toggle The ABN Lookup UI
            toggleButtons.forEach(button =>
                button.addEventListener(`click`, e => {
                    toggleSearchTypeFields(
                        e,
                        toggleButtons,
                        searchFields,
                        resetABNLookupResults,
                        resetSelectedBusinessDetails
                    )
                })
            )
        }

        function requiredField() {

            const x = 2 // 2 Seconds
            const step = document.querySelector(`[data-next]`).dataset.current
            const currentStep = parseInt(step)
            const nextStep = currentStep + 1
            const currentStepWrap = document.querySelector(
                `[data-step="${currentStep}"]`
            )
            const nextStepWrapInput = currentStepWrap.querySelectorAll(
                `[data-required]`
            )
            const formatError = currentStepWrap.querySelector(`[data-form-errors]`)
            const errorFormat = currentStepWrap.querySelector(`[data-format-email]`)

            let count = 0
            const total = nextStepWrapInput.length

            if (nextStepWrapInput && nextStepWrapInput.length > 0) {
                nextStepWrapInput.forEach(element => {
                    if (element.value) {
                        element.classList.remove(`error`)
                        element.parentNode.classList.remove(`error`)
                        if (element.name === `email`) {
                            const emailValue = element.value
                            const error = validate.single(emailValue, {
                                presence: true,
                                email: true,
                            })
                            if (error) {
                                errorFormat.classList.remove(`hide`)
                                errorFormat.parentElement.classList.add(`error`)

                            } else {
                                errorFormat.classList.add(`hide`)
                                count += 1
                            }
                        } else if (element.name === `business_phone`) {
                            if (
                                isAUSite ||
                                isCASite ||
                                isNZSite
                            ) {
                                try {
                                    const number = getRawPhoneNumber(
                                        phoneUtil,
                                        element,
                                        COUNTRY_ISO_CODE
                                    )
                                    if (
                                        phoneUtil.isValidNumberForRegion(number, getStoreCountryCode())
                                    ) {
                                        element.parentElement.classList.remove(`error`)
                                        count += 1
                                    } else {
                                        element.parentElement.classList.add(`error`)
                                    }
                                } catch (error) {
                                    console.error(error)
                                }
                            }
                        } else if (element.name === `phone`) {
                            if (
                                isAUSite ||
                                isCASite ||
                                isNZSite
                            ) {

                                try {
                                    const number = getRawPhoneNumber(
                                        phoneUtil,
                                        element,
                                        COUNTRY_ISO_CODE
                                    )

                                    if (
                                        phoneUtil.isValidNumberForRegion(number, COUNTRY_ISO_CODE) &&
                                        checkIsMobileNumber(phoneUtil, PhoneNumberType, number)
                                    ) {
                                                                                element.parentElement.classList.remove(`error`)
                                        count += 1
                                    } else {
                                                                                element.parentElement.classList.add(`error`)
                                    }
                                } catch (error) {
                                    console.error(error)
                                }
                            } else {
                                const phoneValue = element.value
                                const phoneError = validate(
                                    {duration: phoneValue},
                                    {duration: {numericality: true}}
                                )
                                if (phoneError) {
                                    element.parentElement.classList.add(`error`)

                                } else {
                                    element.parentElement.classList.remove(`error`)
                                    count += 1
                                }
                            }
                        } else if (element.name === `drivers_licence_number`) {
                            if (isAUSite) {
                                if (isValidDriversLicence(
                                    element.value,
                                    document.querySelector(`[name="drivers_license_state_of_issue"]`).value
                                )) {
                                    element.parentElement.classList.remove(`error`)
                                    count += 1
                                } else {
                                    element.parentElement.classList.add(`error`)
                                }
                            } else {
                                count += 1
                            }
                        } else if (element.name === `drivers_licence_card_number`) {
                            if (isAUSite) {
                                if (isValidDriversLicenseCardNumber(
                                    element.value,
                                    document.querySelector(`[name="drivers_license_state_of_issue"]`).value
                                )) {
                                    element.parentElement.classList.remove(`error`)
                                    count += 1
                                } else {
                                    element.parentElement.classList.add(`error`)

                                }
                            } else {
                                count += 1
                            }

                        } else if (element.name === `medicare_card_number`) {
                            if (isAUSite) {
                                // Put a Check in if its not AU / AU Staging store return false
                                const validNumber = validateMedicare(element.value)
                                if (validNumber) {
                                    element.parentElement.classList.remove(`error`)
                                    count += 1
                                } else {
                                    element.parentElement.classList.add(`error`)

                                }
                            }
                        } else if (element.type === `radio`) {
                            if (element.checked) {
                                count += 1
                            }
                        } else if (element.type === `checkbox`) {
                            if (element.checked) {
                                count += 1

                                if (element.id === `commercial_purposes_accepted` && currentStep === 3) {
                                    element.nextElementSibling.classList.remove(`error`)
                                }
                            } else if (element.id === `commercial_purposes_accepted` && currentStep === 3) {
                                element.nextElementSibling.classList.add(`error`)

                            }
                        } else if (element.type === `select-one`) {
                            if (element.value !== ``) {
                                count += 1
                            }
                        } else if (element.name === `business_number`) {
                            if (element.value.length > 6) {
                                const businessValue = element.value
                                const error = validate({number: businessValue}, numberTest)
                                if (error) {
                                    element.classList.add(`numberError`)
                                } else {
                                    element.classList.remove(`numberError`)
                                    count += 1
                                }
                            }
                        } else {
                            count += 1
                        }
                    }
                })
            }

            if (currentStep === 4) {
                if (checkCanGoNext()) {
                    next.classList.remove(`disabled`)
                    next.setAttribute(`data-next`, parseInt(nextStep))
                    if (formatError) {
                        formatError.classList.add(`hide`)
                    }
                } else {
                    next.classList.add(`disabled`)
                    next.setAttribute(`data-next`, ``)
                }
            } else {
                if (total === count) {
                    next.classList.remove(`disabled`)
                    next.setAttribute(`data-next`, parseInt(nextStep))
                    if (formatError) {
                        formatError.classList.add(`hide`)
                    }
                } else if (total > count) {
                    next.classList.add(`disabled`)
                    next.setAttribute(`data-next`, ``)
                }
            }
        }

        const selectItemsValue = document.querySelectorAll(`.slide-down li`)
        if (selectItemsValue) {
            selectItemsValue.forEach(element => {
                element.addEventListener(`click`, () => {
                    const Id = element.parentNode.parentNode.getAttribute(`id`)
                    const val = element.querySelector(`input`).value
                    const triggerElement = document.querySelector(
                        `[data-target="#${Id}"]`
                    )

                    triggerElement.click()
                    triggerElement.querySelector(
                        `[data-value]`
                    ).innerHTML = element.querySelector(`label`).innerHTML
                    triggerElement.querySelector(`input`).value = element.querySelector(
                        `input`
                    ).value
                })
            })
        }

        const closeAccordion = document.querySelector(`.form-overlay`)
        if (closeAccordion) {
            closeAccordion.addEventListener(`click`, e => {
                e.preventDefault()
                const activeAccordion = document.querySelector(
                    `[data-trigger="accordion"].active`
                )
                if (activeAccordion) {
                    activeAccordion.click()
                }
            })
        }

        const showStep = (targetStep, currentStep) => {
            setTimeout(() => {
                stepProgress.classList.remove(`hide`)
                const targetPreviousStepId = targetStep - 1
                const applicationFormSummaryPage = LAST_STEP - 1
                const bodyWrapper = document.querySelector(
                    `.application-form > .container`
                )

                next.classList.add(`disabled`)

                progress.setAttribute(`data-progress`, `step${targetStep}-4`)
                document
                    .querySelector(`.application-form`)
                    .classList.remove(`last-step`)

                window.dataLayer.push({
                    event: `applynow.step`,
                    current_step: currentStep,
                    target_step: targetStep,
                    submission: submissionId
                })

                if (targetPreviousStepId === 1) {
                    next.classList.add(`disabled`)
                }

                if (targetStep === 2) {
                    if (businessToggleCheckbox && businessToggleCheckbox.checked) {
                        applicationBusinessAddress.value = applicationAddress.value
                        applicationBusinessPostcode.value = applicationAddressZip.value
                        applicationBusinessCity.value = applicationAddressCity.value
                    }
                }

                if (
                    targetStep === 3 &&
                    isAUSite
                ) {

                    generateMedicareNameOptions()
                }



                if (targetPreviousStepId === applicationFormSummaryPage) {
                    const birthdayDay = document.querySelector(`[data-birth-day]`)
                    const birthdayMonth = document.querySelector(`[data-birth-month]`)
                    const birthdayYear = document.querySelector(`[data-birth-year]`)
                    setDateOfBirthFieldValues({
                        day: birthdayDay.value,
                        month: birthdayMonth.value,
                        year: birthdayYear.value,
                        country: COUNTRY_ISO_CODE,
                        $formattedBirthdayField: applicationFormattedBirthday,
                        $submittedBirthdayField: applicationSubmittedBirthday,
                    })
                    const summaryPageSelectors = {
                        form,
                        stepProgress,
                        submitApplicationButton,
                    }
                    step4Initial(COUNTRY_ISO_CODE)
                    RenderSummaryPageData(summaryPageSelectors, COUNTRY_ISO_CODE)
                }

                setTimeout(() => {
                    bodyWrapper.scrollTop = 0
                    if (targetPreviousStepId === 0) {
                        back.setAttribute(`data-back-link`, `main`)
                    } else {
                        back.setAttribute(`data-back-link`, targetPreviousStepId)
                    }
                    if (steps && steps.length > 0) {
                        steps.forEach(element => {
                            const stepTarget = parseInt(element.dataset.step)

                            next.setAttribute(`data-current`, parseInt(targetStep))

                            if (stepTarget === targetStep) {
                                element.classList.add(`is-active`)
                            } else {
                                element.classList.remove(`is-active`)
                            }
                        })
                    }
                }, 300)
            }, 200)
            window.scrollTo(0,0)
        }

        if (start) {
            start.addEventListener(`click`, () => {
                const activeStep = document.querySelector(`[data-step="1"]`)
                activeStep.classList.add(`is-active`)
                welcome.classList.add(`hide`)
                form.classList.add(`is-visible`)
                window.scrollTo(0,0)

                steps.forEach(step => {
                    step
                        .querySelectorAll(`[data-required]`)
                        .forEach(field => {
                            field.addEventListener(`change`, requiredField)
                            field.addEventListener(`input`, requiredField)
                        })
                    if (step.querySelector(`#phone_mask`)) {
                                                step.querySelector(`#phone_mask`).addEventListener(`change`, requiredField)
                        step.querySelector(`#phone_mask`).addEventListener(`input`, requiredField)
                    }
                })

                window.dataLayer.push({
                    event: `applynow.start`,
                    target_step: 1,
                    current_step: `start`
                })


            })
        }

        if (container) {
            container.addEventListener(`click`, e => {
                if (e.target === this) {
                    // document.querySelector('[data-target="#application_amount"]').click();
                } else {
                    const app_amount = document.querySelector(
                        `[data-target="#application_amount"].active`
                    )
                    if (app_amount) {
                        app_amount.click()
                    }
                }
            })
        }

        if (editClick) {
            editClick.forEach(element => {
                element.addEventListener(`click`, () => {
                    const currentId = element.dataset.href
                    showStep(parseInt(currentId), `review`)
                })
            })
        }

        if (next) {
            next.addEventListener(`click`, () => {
                requiredField()
                const nextId = next.dataset.next
                const currentId = parseInt(next.dataset.current)

                if (currentId === 1) {
                    // clean retry restriction from step 1
                    localStorage.removeItem(`retryTime`)

                    document.querySelector(`#submission_id`).value = submissionId
                }

                if (nextId !== ``) {
                    if (currentId === 1 || currentId === LAST_STEP) {
                    window.dataLayer.push({
                        event: currentId === 1 ? `AppFormFirstPage` : `AppFormLastPage`,
                        first_name: applicationFirstName.value,
                        middle_name: applicationMiddleName.value,
                        last_name: applicationLastName.value,
                        mobile_number: applicationPhone.value,
                        email_address: applicationEmail.value,
                        submission_id: submissionId,
                        country: isAUSite ? `Australia` : isCASite ? `Canada` : `New Zealand`
                    })
                }
                    showStep(parseInt(nextId), currentId)
                } else {
                    const errorContainer = document.querySelector(
                        `[data-step="${currentId}"] [data-form-errors]`
                    )
                    errorContainer && errorContainer.classList.remove(`hide`)
                    const currentStepWrap = document.querySelector(
                        `[data-step="${currentId}"]`
                    )
                    const nextStepWrapInput = currentStepWrap.querySelectorAll(
                        `[data-required]`
                    )
                    if (nextStepWrapInput && nextStepWrapInput.length > 0) {
                        nextStepWrapInput.forEach(element => {
                            if (element.value === ``) {
                                element.classList.add(`error`)

                                element.parentNode.classList.add(`error`)

                            }
                            if (
                                element.name === `business_number` &&
                                element.value.length < 7
                            ) {
                                element.classList.add(`numberError`)
                            }
                        })
                    }


                }
            })
        }

        if (back) {
            back.addEventListener(`click`, () => {
                const backId = back.dataset.backLink
                const nextId = next.dataset.current
                let current = nextId - 1

                if (backId === `main`) {
                    welcome.classList.remove(`hide`)
                    form.classList.remove(`is-visible`)
                    back.setAttribute(`data-back-link`, `main`)
                } else {
                    current -= 1
                    showStep(parseInt(backId), current+1)
                }

                window.scrollTo(0,0)
            })
        }

        /**
         * Executing functions that are across all international stores
         */
        /**
         * Set the Submit event to the application form
         * 1. Programatically setting the action URL to reduce the amount of spam
         * 2. Prevent the form from submitting when a user presses the Enter Key
         * 3. Add A Disabled State to the Submit Button when the form is submitting to prevent users from clicking multiple times
         */
        preventEnterKeySubmittingForm(applicationFormElement)
        setSubmitApplicationFormEvent(
            applicationFormSubmitButton,
            applicationFormElement
        )
        setMiddleNameDropdownEvent()
        /**
         * Init the Finance Product Descriptive Text
         */
        initFinanceProductDescriptionText()
        /**
         * Google Phone Validation Library for all international stores
         * For mobile and business phone fields
         * Which despite the above comment doesn't use Google..
         */
        ApplicationPhoneFieldValidation(COUNTRY_ISO_CODE)

        /**
         * Bind the google maps places components
         * on page load for all international stores
         */
        window.addEventListener(
            `load`,
            GoogleAddressAutocomplete.bind(null, COUNTRY_ISO_CODE)
        )

        /**
         * AU Application Form Enhancement
         * Only Targeting the AU Store and the AU staging Store
         */
        if (isAUSite) {
            /**
             * Input Mask Validation
             * Targets medicare fields and phone numbers
             */
            ApplicationFormInputMasks(ABNLookupElements)
        }

        if (!isCASite) {
            /**
             * Input Mask Validation
             * Targets Business Lookup
             */
            businessNumberLookupInputMasks(ABNLookupElements)
        }

        /**
         * CA Application Form Enhancements
         * Only Targeting the CA Store
         */
        if (isCASite) {
            /**
             * Allowing users to advance through the form without
             * Providing a Business Number
             */
            const addBusinessNumberLaterCheckbox = $(`#add_business_number_later`)
            const businessNumberInput = $(`input[name="business_number"]`)

            const isEligibleCanadaBusinessNumber = input => input.val().length > 6 // this rule matches the requiredField() - 'business_number' validation check

            const hasInputErrors = input =>
                Boolean(
                    input
                        .attr(`class`)
                        .toString()
                        .toLowerCase()
                        .includes(`error`)
                )

            const hasValue = input => Boolean(input.val())

            const resetCheckbox = checkbox => {
                checkbox.prop(`checked`, false)
                checkbox.attr(`value`, `false`)
                checkbox.attr(`disabled`, ``)
            }

            const removeInputErrors = (input, errorClassname = undefined) => {
                errorClassname
                    ? input && input.removeClass(errorClassname)
                    : input && input.removeClass()
                input && input.parent().removeClass(`error`)
            }

            const setBusinessNumberFieldRequired = (checkbox, input, isChecked) => {
                if (isChecked) {
                    checkbox.value = `true`
                    input.removeAttr(`data-required`)
                } else {
                    checkbox.value = `false`
                    input.attr(`data-required`, ``)
                }
                if (hasInputErrors(input) && isChecked) {
                    removeInputErrors(input)
                }
            }

            const setCheckboxAppearance = (checkbox, input) => {
                if (hasValue(input)) {
                    resetCheckbox(checkbox)
                    input.attr(`data-required`, ``) // make input required to prevent user advancing to next step
                } else {
                    checkbox.removeAttr(`disabled`) // only remove disabled attribute
                    input.attr(`data-required`, ``) // make input required to prevent user advancing to next step
                }
                if (hasInputErrors(input) && isEligibleCanadaBusinessNumber(input)) {
                    removeInputErrors(input)
                }
            }

            addBusinessNumberLaterCheckbox.on(`change`, function () {
                setBusinessNumberFieldRequired(this, businessNumberInput, this.checked)
            })
            businessNumberInput.on(`blur`, function () {
                setCheckboxAppearance(addBusinessNumberLaterCheckbox, $(this))
            })
        }
        const actCallback = function (response) {
            $(`#applicationSubmit`).attr(`data-valid-recaptcha`, `true`)
        }
        const expCallback = function() {
            $(`#applicationSubmit`).attr(`data-valid-recaptcha`, `false`)
        }
        window.onloadCallback = function () {
            const reCaptcha = document.getElementById(`re-captcha`)
            if (reCaptcha) {
                // eslint-disable-next-line no-undef
                grecaptcha.render(document.getElementById(`re-captcha`), {
                    sitekey: `6LerocMUAAAAAB_K4Dcyl6_Xk19ZN5j6y2SDqmbY`,
                    theme: `light`,
                    callback: actCallback,
                    'expired-callback': expCallback,
                    hl: document.getElementsByTagName(`html`)[0].getAttribute(`lang`)
                })
            }
        }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    },
})
